import AnalyticCard from "../../analyticCard/analyticCard";

const TripsCard = () => {
    return(
        <ul className="grid col-4">
            <AnalyticCard data={{number: 23, title: <span>Risky<br/> Drivers</span>}}/>
            <AnalyticCard color={'#DC903A'}
                          backColor={'#FFEBC8'}
                          data={{number: 35, title: <span>Longest<br/> Trips</span>}}/>
            <AnalyticCard color={'#36BA6E'}
                          backColor={'#E3F5EA'}
                          data={{number: 38, title: <span>Efficient<br/> Trips</span>}}/>
            <AnalyticCard color={'#BFBFBF'}
                          backColor={'#F5F5F5'}
                          data={{number: '03', title: <span>Incomplete<br/> Trips</span>}}/>
        </ul>
    )
}

export default TripsCard;
